import * as $ from "jquery";
import OSMap from "./OpenStreetMaps";
import ServiceREST from "Core/ServiceREST";

export class HomepageMap extends ServiceREST {
    // language=JQuery-CSS
    Selector = {
        MAP_ELEMENT_ID: '#homepage_map'
    };

    constructor() {
        super();
        super.rest = this.rest.bind(this);
    }

    public init() {
        let JQMapSelector = $(this.Selector.MAP_ELEMENT_ID);

        if (JQMapSelector.length) {
            let lng: number = JQMapSelector.data('lng');
            let lat: number = JQMapSelector.data('lat');
            let zoom: number = JQMapSelector.data('zoom');
            let url: number = JQMapSelector.data('url');

            const Map = new OSMap();
            Map.init(JQMapSelector.attr('id'), lng, lat, zoom);
            Map.onLoad();

            let response = this.rest('get', url);

            response.then((departments) => {
				if(!(departments instanceof Array))
					return;


                for (let i = 0; i < departments.length; i++) {
                    let department = departments[i];

                    let description =
                        `<div class="mb-2"><span class="homepage-map--title">${department['name']}</span></div>
                        <div class="d-flex justify-content-start flex-row">
                            <div class="homepage-map--icon">
                                <i class="fas fa-map-marker-alt f-12 mr-2" aria-hidden="true"></i>
                            </div>
                            <div class="d-flex justify-content-start flex-column">
                                <div>${department['address1']}</div>
                                <div>${department['address2']}</div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-start flex-row">
                            <div class="homepage-map--icon">
                                <i class="fa fa-phone f-12 mr-2" aria-hidden="true"></i> 
                            </div>
                            <div>
                                Telefon:&nbsp;${department['phone']}
                            </div>
                        </div>
                        <div class="d-flex justify-content-start flex-row">
                            <div class="homepage-map--icon">
                                <i class="fa fa-at f-12 mr-2" aria-hidden="true"></i>
                            </div> 
                            <div>
                                email:&nbsp;${department['email']}
                            </div>
                        </div>
                        <div class="d-flex justify-content-start flex-row">
                            <div class="homepage-map--icon">
                                <i class="fa fa-tag f-12 mr-2" aria-hidden="true"></i>
                            </div>
                            <div>
                                ${department['description']}
                            </div>
                        </div>`
                    Map.addPoint(department.lng, department.lat, description);
                }
            });
            Map.initClickPopover();
        }
    }
}

const HMap = new HomepageMap();
HMap.init();
import * as $ from "jquery";
import OSMap from "./OpenStreetMaps";
import ServiceREST from "Core/ServiceREST";

export class HomepageMap extends ServiceREST {
    // language=JQuery-CSS
    Selector = {
        MAP_ELEMENT_ID: '#homepage_map'
    };

    constructor() {
        super();
        super.rest = this.rest.bind(this);
    }

    public init() {
        let JQMapSelector = $(this.Selector.MAP_ELEMENT_ID);

        if (JQMapSelector.length) {
            let lng: number = JQMapSelector.data('lng');
            let lat: number = JQMapSelector.data('lat');
            let zoom: number = JQMapSelector.data('zoom');
            let url: number = JQMapSelector.data('url');

            const Map = new OSMap();
            Map.init(JQMapSelector.attr('id'), lng, lat, zoom);
            Map.onLoad();

            let response = this.rest('get', url);

            response.then((departments) => {
				if(!(departments instanceof Array))
					return;


                for (let i = 0; i < departments.length; i++) {
                    let department = departments[i];

                    let description =
                        `<div class="mb-2"><span class="homepage-map--title">${department['name']}</span></div>
                        <div class="d-flex justify-content-start flex-row">
                            <div class="homepage-map--icon">
                                <i class="fas fa-map-marker-alt f-12 mr-2" aria-hidden="true"></i>
                            </div>
                            <div class="d-flex justify-content-start flex-column">
                                <div>${department['address1']}</div>
                                <div>${department['address2']}</div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-start flex-row">
                            <div class="homepage-map--icon">
                                <i class="fa fa-phone f-12 mr-2" aria-hidden="true"></i> 
                            </div>
                            <div>
                                Telefon:&nbsp;${department['phone']}
                            </div>
                        </div>
                        <div class="d-flex justify-content-start flex-row">
                            <div class="homepage-map--icon">
                                <i class="fa fa-at f-12 mr-2" aria-hidden="true"></i>
                            </div> 
                            <div>
                                email:&nbsp;${department['email']}
                            </div>
                        </div>
                        <div class="d-flex justify-content-start flex-row">
                            <div class="homepage-map--icon">
                                <i class="fa fa-tag f-12 mr-2" aria-hidden="true"></i>
                            </div>
                            <div>
                                ${department['description']}
                            </div>
                        </div>`
                    Map.addPoint(department.lng, department.lat, description);
                }
            });
            Map.initClickPopover();
        }
    }
}

const HMap = new HomepageMap();
HMap.init();
